export const zh = "local_h/zh.json";
export const en = "local_h/en.json";



// WEBPACK FOOTER //
// ./src/assets/i18n/local_h/index.ts